import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ProductSlider/productSlider.container"
    ).then((module) => ({
        default: module.ProductSlider
    }))
);
